/* eslint-disable max-len */
import styled, { css } from 'styled-components';
import Tabs from 'components/ui/Tabs';
import TextInput from 'components/ui/TextInput';
import Input from 'components/ui/Input';
import TextArea from 'components/ui/TextArea';
import Label from 'components/ui/Label';
import Select from 'components/ui/Select';
import { Row, Column } from 'components/shared/Layout';

import { colours, common } from 'themes/default';

export const StyledTextInput = styled(TextInput)`
  width: 100%;
  box-sizing: border-box;
  margin-top: 5px;

  &:read-only {
    background: ${colours.Greyscale.MistGrey};
  }
`;

export const StyledClubEurostarMemberContainer = styled.div`
  padding: 0 25px;
`;

export const ClubEurostarMemberContent = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1024px;
  margin: auto;
`;

export const MemberInfoSection = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
`;

export const AccountInfoSection = styled.div`
  padding: 25px 0 40px 0;
`;

export const SubscriptionInfoSection = styled.div`
  padding: 25px 0 40px 0;
`;

export const SectionContainer = styled.div`
  margin: 40px 0;
`;

export const SectionTitleContainer = styled.div`
  margin-bottom: 25px;
`;

export const SectionTableContainer = styled.div`
  margin-bottom: 40px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const BookingsTabsContainer = styled.div`
  display: inline-block;
  margin: 0 0 0 25px;
`;

export const BookingsTitle = styled.div`
  display: inline-block;
`;

export const BookingsTabs = styled(Tabs)`
  width: 400px;
  height: 42px;
`;

export const MemberName = styled.div`
  font-size: 2rem;
`;

export const MemberInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px 0 40px 0;
  gap: 16px;
`;

export const MemberInfoRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  min-width: 320px;
  flex: 1;
`;

export const MemberInfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  flex: 1;
  justify-content: flex-end;
`;

export const AccountInfoContainer = styled.div`
  display: flex;
  width: 100%;

  ${({ align }) => {
    if (align) {
      return css`
        align-items: ${align};
      `;
    }

    return css`
      align-items: center;
    `;
  }}
`;

export const AccountInfoColumn = styled.div`
  flex: 1 0 50%;
  box-sizing: border-box;
  :first-child {
    padding-right: 10px;
  }
  :last-child {
    padding-left: 10px;
  }
`;

export const TierName = styled.div`
  font-size: 18px;
  font-style: italic;
  margin-bottom: 16px;

  & strong {
    font-size: 24px;
    color: ${colours.Core.SecondaryPlum};
  }
`;

export const TierImage = styled.div`
  width: 120px;
  height: 80px;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ tierName }) => {
    if (tierName.toLowerCase() === 'Carte Blanche'.toLowerCase()) {
      return css`
        background-color: ${common.clubEurostar.carteBlanche};
      `;
    }

    if (tierName.toLowerCase() === 'Elite'.toLowerCase()) {
      return css`
        background-color: ${common.clubEurostar.elite};
      `;
    }

    if (tierName.toLowerCase() === 'Etoile'.toLowerCase()) {
      return css`
        background-color: ${common.clubEurostar.etoile};
      `;
    }
    if (tierName.toLowerCase() === 'Avantage'.toLowerCase()) {
      return css`
        background-color: ${common.clubEurostar.avantage};
      `;
    }

    return css`
      background-color: ${common.clubEurostar.classique};
    `;
  }}
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  border-radius: 5px;
  margin-top: 5px;
  cursor: pointer;
`;

export const StyledLabel = styled.label`
  display: block;
  font-weight: bolder;
`;

export const TierTitleImageContainer = styled.div`
  & img {
    height: 28px;
  }
`;

export const TierInfoContainer = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
`;

export const TierInfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  gap: 8px;
`;

export const TierInfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TierInfoItemLabel = styled.span`
  font-style: italic;
`;

export const TierInfoItemValue = styled.span`
  display: inline-flex;
  border-radius: 3px;
  padding: 2px 4px;
  background-color: rgb(242, 242, 242);
`;

export const PointsLabel = styled.span`
  text-transform: lowercase;
`;

export const Error = styled.div`
  color: red;
`;

export const BookingLink = styled.a`
  color: ${colours.Core.SecondaryPlum};
`;

export const BookingCancelled = styled.div`
  color: ${colours.Core.SecondaryPlum};
  margin: 7px;
`;

export const StyledTableRow = styled(Row)`
  grid-column-gap: 0;
  margin-bottom: 0;
  max-height: ${({ expandable, expanded }) => (!expandable || expanded ? '100px' : '1px')};
  overflow: hidden;
  position: relative;
  transition: max-height 0.3s ease-in-out;
`;

export const StyledDescriptionList = styled.dl`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
`;

export const StyledDescriptionTerm = styled.dt`
  display: inline-block;
  font-weight: bold;
  margin: 0 5px 0 0;

  &::after {
    content: ': ';
  }
`;

export const StyledDescriptionDetails = styled.dd`
  display: inline-block;
  margin: 0 20px 0 0;

  &:last-child {
    margin: 0;
  }
`;

export const StyledRowExpander = styled.button`
  align-items: center;
  background: none;
  border: none;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  height: 24px;
  justify-content: center;
  left: 0;
  outline: none;
  padding: 0;
  position: absolute;
  width: 24px;

  > svg {
    transform: rotate(${({ expanded }) => (expanded ? '90deg' : '0')});
    transition: transform 0.3s ease-in-out;
  }
`;

export const StyledTableHeader = styled(Column)`
  padding: 5px;
  background-color: ${colours.Shades.TintBlue10};
  color: ${colours.Greyscale.CharcoalGrey};
  border-top: 1px solid ${colours.Core.SecondaryPlum};
  border-bottom: 1px solid ${colours.Core.SecondaryPlum};
  border-right: 1px solid ${colours.Core.SecondaryPlum};

  &:first-child {
    border-left: 1px solid ${colours.Core.SecondaryPlum};
  }
`;

export const StyledTableCell = styled(Column)`
  padding: 5px;
  border-bottom: 1px solid ${colours.Greyscale.SilverGrey};
  border-right: 1px solid ${colours.Greyscale.SilverGrey};

  &:first-child {
    border-left: 1px solid ${colours.Greyscale.SilverGrey};
  }
`;

export const SectionTitle = styled.div`
  padding-top: 15px;
  font-size: 28px;
  font-weight: 300;
`;

export const AccountDetailsItemValue = styled.span`
  margin-left: 10px;
`;

export const DetailsItemContainer = styled.div`
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: start;

  & button[type='submit'] {
    margin-right: 5px;
  }
`;

export const StyledInput = styled(TextInput)`
  width: 100%;
  margin-top: 5px;
`;

export const StyledDateOfBirthInput = styled(TextInput)`
  width: 80px;
  margin-top: 8px;
  margin-right: 10px;

  &:read-only {
    background: ${colours.Greyscale.MistGrey};
  }
`;

export const CheckBoxWrapper = styled.div`
  width: 50px;
  display: inline-block;
  vertical-align: bottom;

  & div {
    background: ${colours.Greyscale.MistGrey};
  }

  & div[aria-checked='true'] {
    border: 1px solid ${colours.Greyscale.SilverGrey};

    & svg {
      stroke: ${colours.Shades.BlueShade40};
    }
  }
`;

export const FindContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 465px;
`;

export const FindInput = styled(Input)`
  width: 100%;
  margin-bottom: 16px;
`;

export const ActionsList = styled.div`
  display: flex;
  gap: 20px;
`;

export const PointsInput = styled(Input)`
  width: 160px;
  margin-bottom: 4px;
`;

export const AdjustPointsReasonTextArea = styled(TextArea)`
  width: 500px;
  resize: vertical;
`;

export const AdjustPointsReasonSelect = styled(Select)`
  max-width: 500px;
  margin-bottom: 4px;
`;

export const MandatoryFieldLabel = styled(Label)`
  &::after {
    content: ' *';
    color: red;
  }
`;

export const PointsFormField = styled.div`
  margin-bottom: 16px;
`;

export const AdditionalNotesIcon = styled.img`
  height: 16px;
  margin-left: 4px;
`;

export const ClaimMissingPointsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;

export const ErrorContainer = styled.div`
  white-space: pre-wrap;
  font-size: 14px;
  margin-bottom: 12px;
  padding: 8px;
  background-color: ${colours.Greyscale.Eggshell};
`;

export const AddBookingFormWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;
